export const addProperties = (payload) => {
  if (!Array.isArray(payload)) {
    return []
  }

  return payload
    .map((item) => ({
      ...item,
      name: item.companyName,
    }))
    .sort((a, b) => a.companyName.localeCompare(b.companyName))
}
